export default __webpack_public_path__ + "static/03-Andreatta_Waterscapes_Pondless_Waterfall_Ashland_Oregon-61417a2e0488a91eb8d1d68a9155bf13.jpg";